import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Form, Button } from "react-bootstrap";
import "./SearchbarSection.css";
import { FaSearch } from "react-icons/fa";

const SearchbarSection = () => {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const handleSearch = () => {
    if (keyword.trim()) {
      navigate(`/search-vehicles?keyword=${encodeURIComponent(keyword)}`);
    }
  };

  return (
    <Form className="searchbar-section">
      <Button variant="custom-teal" className="search-button">
        Search Car
      </Button>
      <Form.Control
        type="text"
        placeholder="Enter car name or model"
        className="search-input"
        value={keyword}
        onChange={(e) => setKeyword(e.target.value)}
        onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
      />
      <Button variant="custom-teal" className="icon-button" onClick={handleSearch}>
        <FaSearch />
      </Button>
    </Form>
  );
};

export default SearchbarSection;